module.exports = __webpack_public_path__ + "img/comment-photo.594ed8b3.png";